module.exports = __webpack_public_path__ + "img/slider_6.51cc2b19.jpg";